import React from "react";
import "./pageLoader.scss";
import Image from "next/image";

import coinImg from "@/../public/header/coin.png";

export default function PageLoader() {
  /* 
${
        isAllTemplatesLoading ? "show" : "hide"
      }
*/

  return (
    <div className={`flex-col-center PageLoader `}>
      <div className="flex-row-center coinImgContainer show">
        <Image src={coinImg} width={100} height={100} alt="coin" />
      </div>
      <div className="loader1"></div>
    </div>
  );
}
